import React from 'react';
import { ReadOnlyItem } from '@ydistri/ds';

export interface IdentificationItem {
  label: string;
  value: string;
}

interface IdentificationsProps {
  items: IdentificationItem[];
  spaceBetween?: string;
}

const Identifications: React.FC<IdentificationsProps> = ({ items, spaceBetween }) => {
  if (items.length === 0) return null;

  return (
    <>
      {items.map(item => (
        <ReadOnlyItem
          label={item.label}
          value={item.value}
          key={`${item.label}-${item.value}`}
          spaceBetween={spaceBetween}
        />
      ))}
    </>
  );
};

export default React.memo(Identifications);
